module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0012.jpg?v=d3f713f4";